<template>
  <autocomplete-preset :api="api" :fields="['name', 'customId', 'status', 'acquisitionStatus']" :resp-mapper="respMapper" :value="value"
                       v-bind="$props" @input="$emit('input', $event)"/>
</template>
<script lang="ts">
import AutocompleteMixin from '@/mixins/autocompletes/Autocomplete.mixin';
import {Institution} from '@/interfaces/institution.interface';
import {InstitutionerApi} from '@/classes/api/institutioner.api.class';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {InstitutionFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/InstitutionFields';
import {
  AcquisitionListStatusEnum,
} from "@/enums/institutioner/acquisition/AcquisitionListStatus.enum";

import {PickerTag, PickerTone} from '@/components/common/entity-picker/entityPicker.types';

const STATUS_TONE: Partial<Record<AcquisitionListStatusEnum, PickerTone>> = {
  [AcquisitionListStatusEnum.OPEN]: 'warn',
  [AcquisitionListStatusEnum.POTENTIAL]: 'purple',
  [AcquisitionListStatusEnum.AI_SUCCESS]: 'teal',
  [AcquisitionListStatusEnum.IN_PROGRESS]: 'info',
  [AcquisitionListStatusEnum.COMMITTED]: 'good',
  [AcquisitionListStatusEnum.CLOSED]: 'bad',
};

export default AutocompleteMixin.extend({
  props: {
    disablePotential: {type: Boolean, default: false},
  },
  computed: {
    api: () => InstitutionerApi,
  },
  methods: {
    respMapper(resp: { institutions: Institution[] }) {
      return resp.institutions.map((institution) => {
        const canAccessStatus = this.$$crudAccessManager.entity(CrudEntityTypes.INSTITUTION, institution._id).canRead(InstitutionFields.ACQUISITION_STATUS);
        const isOpen = institution.acquisitionStatus === AcquisitionListStatusEnum.OPEN;
        const statusItem = AcquisitionListStatusEnum.Record[institution.acquisitionStatus];
        const description = !canAccessStatus ? 'Kein Lesezugriff auf Standortstatus'
            : isOpen && this.disablePotential ? 'Offene Standorte können in diesem Kontext nicht ausgewählt werden'
                : statusItem?.text;
        const disabled = !canAccessStatus || isOpen && this.disablePotential;

        const tags: PickerTag[] = canAccessStatus && statusItem
            ? [{text: statusItem.text, tone: STATUS_TONE[institution.acquisitionStatus] || 'muted', icon: statusItem.icon}]
            : [];

        return {
          text: (institution.name || 'Unbekannter Standort') + ' (' + (institution.customId || 'Unbekannte ID') + ')',
          value: institution._id,
          description,
          disabled,
          entity: 'institution' as const,
          customId: institution.customId,
          tags,
          // The status is shown as tag; reasons for a disabled item get their own line
          subtitle: description === statusItem?.text ? '' : undefined,
          disabledReason: disabled ? description : undefined,
        };
      });
    },
  },
});
</script>
